import { extractProperties } from './attributes';
import { emit } from './emitter';
import { observeNewElements } from './mutationObserver';

const VIEW_SELECTOR = '[data-observe-view]';
const viewedElements = new WeakSet<Element>();

const createIntersectionObserver = (): IntersectionObserver =>
  new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        if (viewedElements.has(entry.target)) return;

        const eventName = entry.target.getAttribute('data-observe-view');
        if (!eventName) return;

        viewedElements.add(entry.target);

        const properties = extractProperties(entry.target);
        emit(eventName, { observed: 'view', ...properties });
      });
    },
    { threshold: 0.5 }
  );

export const initViewObserver = (): void => {
  const intersectionObserver = createIntersectionObserver();

  // Observe existing elements
  document.querySelectorAll(VIEW_SELECTOR).forEach((element) => {
    intersectionObserver.observe(element);
  });

  // Watch for dynamically added elements
  observeNewElements(VIEW_SELECTOR, (element) => {
    intersectionObserver.observe(element);
  });
};
